import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/shared/components/Component";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import "src/features/home/pages/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/shared/components/withAppContext";
import { withRouter } from 'react-router-dom';
import LoadingSpinner from "src/shared/components/LoadingSpinner";
import { FILE_URL } from "src/constants";
import Footerpage from "src/shared/components/footer";
import Headerpage from "src/shared/components/header";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
const styles = () => ({
    childTemplate: {
        paddingLeft: 80,
    },
    listItem: {
        "&:hover": {
            backgroundColor: "#e6e6e6",
        },
        backgroundColor: "white",
    },
});

type IProps = IAxiosProps & IAppContext &
    WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
    paymentDetails: any
    loader: boolean;
    openAgreement: boolean;
    paymentMethodType: number;
    isAgree: boolean;
    newUserDetails: any,
    inVoiceUrl: any

}

const Payment = withStyles(styles)(
    withAxios(
        class LeadPage extends Component<IProps, ITemplatesPageState> {
            public state = this.buildState({
                paymentDetails: {},
                loader: false,
                openAgreement: false,
                paymentMethodType: 0,
                isAgree: false,
                newUserDetails: {},
                inVoiceUrl: {}
            });
            // public handlePopState: (event: any) => void;
            public componentWillMount(): void {

                this.props.getNewLoginUserDetails()
            }
            public componentDidMount() {
                this.getRegisterUserDetails()
                window.history.pushState(null, "", window.location.href);

                // this.handlePopState = (event) => {
                //     // Prevent back button by pushing a new entry again
                //     window.history.pushState(null, "", window.location.href);
                // };

                // // Add an event listener to detect back button navigation
                // window.addEventListener('popstate', this.handlePopState);
            }
            public handleBackButton = (event: PopStateEvent) => {
                console.log(event, "EVENT====>?")
            };
            public componentWillUnmount() {
                // window.removeEventListener('popstate', this.handlePopState);
            }
            public getRegisterUserDetails = () => {
                const storedObject: string = sessionStorage.getItem("newUserDetails") || '{}';  // Fallback to an empty object string
                const parsedObject = JSON.parse(storedObject);
                if (Object.keys(parsedObject).length > 0) {
                    this.setState({ newUserDetails: parsedObject }, () => {
                        this.getAllPlanHandler()
                        this.InvoiceDownload()
                    })
                }
            }
            public async getAllPlanHandler() {
                this.setState({ loader: true })
                const planId: any = this.state.newUserDetails?.subscriptionPlan?.id
                const addonId: any = this.state.newUserDetails?.addonPlan || []
                const paymentData = {
                    // "payment_method":"cheque",
                    "plan_id": planId,
                    "addon_id": addonId
                }
                const res: any = await this.buildPost(this, "payment/planPayNow")(paymentData)
                if (res.status && Object.keys(res?.data)?.length > 0) {
                    this.setState({ paymentDetails: { ...res?.data, addon: res?.data?.addon == null ? [] : res?.data?.addon, plan: res?.data?.plan != null ? res?.data?.plan : {} } }, () => {
                        console.log("paymentDetails======>", this.state.paymentDetails)
                    })
                    this.setState({ loader: false })
                } else {
                    this.setState({ loader: false })
                }
                // this.setState({ user: res })
            }

            public TwoDecimalFloat(amount: any) {
                const valueAnount = amount;
                const roundedNumber = valueAnount.toFixed(2);
                return roundedNumber

            }

            public InvoiceDownload = async () => {
                // this.props.getNewLoginUserDetails()
                const InvoiceId = this.state.newUserDetails?.paymentRes?.data?.memberPayHistory?.payment?.id
                if (InvoiceId) {
                    const resInvoice: any = await this.buildGet(this, `payment/invoice/${InvoiceId}`)()
                    console.log("resInvoice======>", resInvoice)
                    if (resInvoice?.status) {
                        const InvoiceUrlObject = resInvoice?.data?.result_data || {}
                        const InvoiceURL = JSON?.parse(InvoiceUrlObject)?.invoice
                        const InvoicNumber = JSON?.parse(InvoiceUrlObject)?.invoiceNumber
                        this.setState({ inVoiceUrl: { url: FILE_URL + "/" + InvoiceURL, name: InvoicNumber + ".pdf" } })
                    }
                }
            }
            public render() {
                return (
                    <>
                     <div className="contat-main-bg-color">
                      {this.state.loader &&<div className="loader-bg-color">
                        <LoadingSpinner /></div>}

                        <Headerpage/>
                        <div className="container">
                            <div className="purchase-content">
                                <div className="row purchase-row">
                                    <div className="col-lg-8">
                                        {Object.keys(this.state?.paymentDetails)?.length > 0 && <div className="purchase-inner-content">
                                            <div className="purchase-inform"><h3>Your subscription has been successfully processed.</h3></div>
                                            {Object?.keys(this.state?.paymentDetails?.plan)?.length > 0 && <div className="subscription-fee">
                                                <div className="subscription-fee-flex">
                                                    <div className="sub-yearly">
                                                        <h4>Subscription {this.state?.paymentDetails?.plan?.id === 1 ? "Fee" : "Fees"}<br />
                                                            ({this.state?.paymentDetails?.plan?.title}/{this.state?.paymentDetails?.plan?.payment_frequency_type.charAt(0).toUpperCase() + this.state?.paymentDetails?.plan?.payment_frequency_type.slice(1)})</h4>
                                                    </div>
                                                    <div>
                                                        <h3> ${this.TwoDecimalFloat(this.state?.paymentDetails?.plan?.price)}</h3>
                                                    </div>
                                                </div>
                                            </div>}
                                            {this.state?.paymentDetails?.addon?.length > 0 && this.state?.paymentDetails?.addon.map((item: any) => {
                                                return (
                                                    <div className="customizeable" key={item?.id}>
                                                        <div className="subscription-sub-flex">
                                                            <div className="sub-custom">
                                                                <h4>{item?.title}
                                                                    <br />
                                                                    (Add on) </h4>
                                                            </div>
                                                            <div>
                                                                <h3>${this.TwoDecimalFloat(item?.price)}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )

                                            })



                                            }
                                            <div className="totalprice downloadsuccess"><h3>Total: ${this.TwoDecimalFloat(this.state?.paymentDetails?.total)}</h3></div>
                                            <div>
                                                {/* {(this.state.inVoiceUrl?.url &&this.state?.paymentDetails?.total===0)&&
                                                    <button className="down-invoice" >
                                                        <a href={this.state.inVoiceUrl?.url} download={this.state.inVoiceUrl?.name} style={{ color: 'white' }} target="_blank">
                                                            Download Invoice
                                                        </a>
                                                    </button>
                                                } */}


                                                <button className="dashboard" onClick={() => {
                                                    this.props.userLogout();
                                                    this.setState({loader:true})
                                                    
                                                  setTimeout(() => {
                                                    this.props.removeNewUserDetails()
                                                    this.setState({loader:false})
                                                    this.props.history.replace('/sign-in')
                                                    }, 5000);
                                                   
                                                }}>Login</button>
                                            </div>

                                        </div>}

                                    </div>

                                </div>
                            </div>

                        </div>

<Footerpage/>
                        </div>
                    </>
                );
            }
        }
    )
);



const PaymentFunction = (props: any) => (
    <AppContextConsumer>{(context) => <Payment {...context} history={props?.history} />}</AppContextConsumer>
);
export default withRouter(PaymentFunction);












// WEBPACK FOOTER //
// ./src/features/director/pages/payment/paymentSucessfull.tsx